<template>
  <div class="point_error">
    <section class="text_center">
      <h2 class="header_underline">G-MONEY(ジーマネー)決済キャンセル</h2>
      <p class="point_error_notice">G-MONEY(ジーマネー)決済をキャンセルしました。</p>
      <p>
        <router-link :to="{ name: 'PointGmoneyForm' }" class="arrow link_main--text">ポイント購入ページに戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PointGmoneyCancel'
}
</script>
